// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mui-even,
.Mui-odd {
  border-bottom: 1px solid transparent;
}

.mission-page-greeting {
  margin: 0 0 10px 0;
  font-size: 1.9rem;
  font-weight: 700;
  color: #0f172a;
}

.mission-page-tabs {
  margin-top: 0;
}

.mission-main-tabpanel {
  margin-top: 18px;
}

.mission-main-tabpanel--secondary {
  margin-top: 18px;
}

.mission-main-tabpanel--mapping {
  margin-top: 0;
}

.mission-section-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #001843;
}

.mission-list-panel {
  border: 1px solid #d5dfed;
  border-radius: 14px;
  padding: 16px;
  background: #fcfdff;
  width: 100%;
  box-sizing: border-box;
  margin-top: 18px;
}

.mission-list-title {
  margin: 0 0 12px 2px;
  font-size: 1.12rem;
  font-weight: 700;
  color: #1f2937;
}

.missionBox-scroll {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 4px;
}

.missionBox-scroll::-webkit-scrollbar {
  width: 8px;
}

.missionBox-scroll::-webkit-scrollbar-track {
  background: #eef2f7;
  border-radius: 999px;
}

.missionBox-scroll::-webkit-scrollbar-thumb {
  background: #c2ccdc;
  border-radius: 999px;
}

.missionBox-scroll::-webkit-scrollbar-thumb:hover {
  background: #aebad0;
}

.mission-list-panel .missionBox-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  align-items: stretch;
}

.css-19kzrtu {
  padding: 0 !important;
}

/* ===== Dashboard (incyia redesign) ===== */
.dash-page,
.dash-page * {
  font-family: Lato, sans-serif !important;
}

.dash-page .dash-reuse-big,
.dash-page .dash-tab-n,
.dash-page .dmt-prio-v,
.dash-page .dmt-prio-sub b,
.dash-page .dmt-mono,
.dash-page .dmt-donut-note b,
.dash-page .dmt-tp-n,
.dash-page .dmt-mini-row .v,
.dash-page .dmap-kpi-v,
.dash-page .dmap-kpi-of,
.dash-page .dmap-mono,
.dash-page .dmap-map-frac {
  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;
}

.dash-page-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.dash-eyebrow {
  font-size: 13.125px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #8b99b4;
  margin-bottom: 9px;
}

.dash-title {
  margin: 0;
  font-size: 33.75px;
  font-weight: 700;
  color: #0b1e2d;
  letter-spacing: -0.008em;
  line-height: 1.12;
}

.dash-sub {
  margin: 6px 0 0;
  color: #5b6b87;
  font-size: 16.875px;
  max-width: 70ch;
  line-height: 1.5;
}

.dash-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dash-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 45px;
  padding: 0 17.5px;
  border-radius: 8px;
  font-size: 16.25px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
  width: auto !important;
}

.dash-btn-primary {
  border: none;
  background: #0d9b87;
  color: #fff;
}

.dash-btn-primary:hover {
  background: #076b5c;
}

.dash-btn-ghost {
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #0b1e2d;
}

.dash-btn-ghost:hover {
  background: #f7fafa;
  border-color: #c5d0d6;
}

.dash-btn-sm {
  height: 37.5px;
  padding: 0 12.5px;
  font-size: 15.625px;
}

.dash-posture {
  position: relative;
  overflow: hidden;
  border-radius: 17.5px;
  padding: 35px 37.5px;
  margin-bottom: 22px;
  background: linear-gradient(118deg, #040b26 0%, #00146d 46%, #0a3a78 78%, #0e5a86 100%);
  border: 1px solid rgba(255, 255, 255, 0.09);
  color: #d5def2;
}

.dash-posture::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
    720px 280px at 88% -25%,
    rgba(57, 202, 171, 0.3),
    transparent 70%
  );
}

.dash-posture::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.35;
  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 44px 44px;
}

.dash-posture-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(240px, 0.85fr) 1px minmax(300px, 1.4fr);
  gap: 30px;
  align-items: center;
}

.dash-rule-v {
  background: linear-gradient(
    180deg,
    transparent,
    rgba(255, 255, 255, 0.22),
    transparent
  );
  align-self: stretch;
}

.dash-posture-eyebrow {
  font-size: 13.125px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7c93c8;
}

.dash-reuse {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-top: 10px;
}

.dash-reuse-big {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-weight: 600;
  font-size: 82.5px;
  line-height: 0.86;
  letter-spacing: -0.035em;
  color: #4fe0c2;
  text-shadow: 0 0 34px rgba(79, 224, 194, 0.35);
}

.dash-reuse-unit {
  font-weight: 600;
  font-size: 25px;
  color: #8fa6d9;
}

.dash-lede {
  color: #9db0d6;
  font-size: 16.25px;
  line-height: 1.6;
  margin: 12px 0 0;
  max-width: 36ch;
}

.dash-ladder {
  display: flex;
  gap: 7px;
}

.dash-rung {
  flex: 1 1;
  height: 11.25px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.14);
}

.dash-rung.on {
  background: #4fe0c2;
  box-shadow: 0 0 16px rgba(79, 224, 194, 0.5);
}

.dash-ladder-lbl {
  display: flex;
  gap: 7px;
  margin-top: 10px;
}

.dash-ladder-lbl span {
  flex: 1 1;
  font-size: 14.375px;
  color: #7e93c8;
}

.dash-ladder-lbl span.on {
  color: #4fe0c2;
  font-weight: 500;
}

.dash-ladder-note {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 25px;
  padding-top: 18.75px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  font-size: 15.625px;
  color: #a9bae0;
}

.dash-ladder-note .dash-btn-ghost {
  flex: none;
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.dash-ladder-note .dash-btn-ghost:hover {
  background: rgba(255, 255, 255, 0.18);
}

.dash-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #dfe7e8;
  margin: 20px 0;
  overflow-x: auto;
}

.dash-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  font-size: 16.875px;
  color: #5f7484;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;
  background: transparent;
  cursor: pointer;
  font-family: Lato, sans-serif;
  transition: color 0.14s, border-color 0.14s;
  width: auto !important;
}

.dash-tab:hover {
  color: #0b1e2d;
}

.dash-tab.on {
  color: #012060;
  border-bottom-color: #012060;
  font-weight: 500;
}

.dash-tab-n {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 13.125px;
  padding: 1px 7px;
  border-radius: 99px;
  background: #eaf0f0;
  color: #5f7484;
}

.dash-tab.on .dash-tab-n {
  background: #e8eef8;
  color: #012060;
}

@media (max-width: 980px) {
  .dash-posture-grid {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .dash-rule-v {
    display: none;
  }

  .dash-reuse-big {
    font-size: 52px;
  }

  .dash-ladder-note {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .dash-title {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/mission/mission.css"],"names":[],"mappings":"AAAA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;;EAEE,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;EAYE,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uFAAuF;EACvF,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;0EACwE;EACxE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qEAAqE;EACrE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;;;;GAKC;EACD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".Mui-even,\n.Mui-odd {\n  border-bottom: 1px solid transparent;\n}\n\n.mission-page-greeting {\n  margin: 0 0 10px 0;\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.mission-page-tabs {\n  margin-top: 0;\n}\n\n.mission-main-tabpanel {\n  margin-top: 18px;\n}\n\n.mission-main-tabpanel--secondary {\n  margin-top: 18px;\n}\n\n.mission-main-tabpanel--mapping {\n  margin-top: 0;\n}\n\n.mission-section-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #001843;\n}\n\n.mission-list-panel {\n  border: 1px solid #d5dfed;\n  border-radius: 14px;\n  padding: 16px;\n  background: #fcfdff;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 18px;\n}\n\n.mission-list-title {\n  margin: 0 0 12px 2px;\n  font-size: 1.12rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.missionBox-scroll {\n  max-height: 420px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.missionBox-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.missionBox-scroll::-webkit-scrollbar-track {\n  background: #eef2f7;\n  border-radius: 999px;\n}\n\n.missionBox-scroll::-webkit-scrollbar-thumb {\n  background: #c2ccdc;\n  border-radius: 999px;\n}\n\n.missionBox-scroll::-webkit-scrollbar-thumb:hover {\n  background: #aebad0;\n}\n\n.mission-list-panel .missionBox-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 14px;\n  align-items: stretch;\n}\n\n.css-19kzrtu {\n  padding: 0 !important;\n}\n\n/* ===== Dashboard (incyia redesign) ===== */\n.dash-page,\n.dash-page * {\n  font-family: Lato, sans-serif !important;\n}\n\n.dash-page .dash-reuse-big,\n.dash-page .dash-tab-n,\n.dash-page .dmt-prio-v,\n.dash-page .dmt-prio-sub b,\n.dash-page .dmt-mono,\n.dash-page .dmt-donut-note b,\n.dash-page .dmt-tp-n,\n.dash-page .dmt-mini-row .v,\n.dash-page .dmap-kpi-v,\n.dash-page .dmap-kpi-of,\n.dash-page .dmap-mono,\n.dash-page .dmap-map-frac {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;\n}\n\n.dash-page-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.dash-eyebrow {\n  font-size: 13.125px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #8b99b4;\n  margin-bottom: 9px;\n}\n\n.dash-title {\n  margin: 0;\n  font-size: 33.75px;\n  font-weight: 700;\n  color: #0b1e2d;\n  letter-spacing: -0.008em;\n  line-height: 1.12;\n}\n\n.dash-sub {\n  margin: 6px 0 0;\n  color: #5b6b87;\n  font-size: 16.875px;\n  max-width: 70ch;\n  line-height: 1.5;\n}\n\n.dash-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dash-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 45px;\n  padding: 0 17.5px;\n  border-radius: 8px;\n  font-size: 16.25px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n  width: auto !important;\n}\n\n.dash-btn-primary {\n  border: none;\n  background: #0d9b87;\n  color: #fff;\n}\n\n.dash-btn-primary:hover {\n  background: #076b5c;\n}\n\n.dash-btn-ghost {\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #0b1e2d;\n}\n\n.dash-btn-ghost:hover {\n  background: #f7fafa;\n  border-color: #c5d0d6;\n}\n\n.dash-btn-sm {\n  height: 37.5px;\n  padding: 0 12.5px;\n  font-size: 15.625px;\n}\n\n.dash-posture {\n  position: relative;\n  overflow: hidden;\n  border-radius: 17.5px;\n  padding: 35px 37.5px;\n  margin-bottom: 22px;\n  background: linear-gradient(118deg, #040b26 0%, #00146d 46%, #0a3a78 78%, #0e5a86 100%);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  color: #d5def2;\n}\n\n.dash-posture::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: radial-gradient(\n    720px 280px at 88% -25%,\n    rgba(57, 202, 171, 0.3),\n    transparent 70%\n  );\n}\n\n.dash-posture::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.35;\n  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 44px 44px;\n}\n\n.dash-posture-grid {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: minmax(240px, 0.85fr) 1px minmax(300px, 1.4fr);\n  gap: 30px;\n  align-items: center;\n}\n\n.dash-rule-v {\n  background: linear-gradient(\n    180deg,\n    transparent,\n    rgba(255, 255, 255, 0.22),\n    transparent\n  );\n  align-self: stretch;\n}\n\n.dash-posture-eyebrow {\n  font-size: 13.125px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7c93c8;\n}\n\n.dash-reuse {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.dash-reuse-big {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-weight: 600;\n  font-size: 82.5px;\n  line-height: 0.86;\n  letter-spacing: -0.035em;\n  color: #4fe0c2;\n  text-shadow: 0 0 34px rgba(79, 224, 194, 0.35);\n}\n\n.dash-reuse-unit {\n  font-weight: 600;\n  font-size: 25px;\n  color: #8fa6d9;\n}\n\n.dash-lede {\n  color: #9db0d6;\n  font-size: 16.25px;\n  line-height: 1.6;\n  margin: 12px 0 0;\n  max-width: 36ch;\n}\n\n.dash-ladder {\n  display: flex;\n  gap: 7px;\n}\n\n.dash-rung {\n  flex: 1;\n  height: 11.25px;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.dash-rung.on {\n  background: #4fe0c2;\n  box-shadow: 0 0 16px rgba(79, 224, 194, 0.5);\n}\n\n.dash-ladder-lbl {\n  display: flex;\n  gap: 7px;\n  margin-top: 10px;\n}\n\n.dash-ladder-lbl span {\n  flex: 1;\n  font-size: 14.375px;\n  color: #7e93c8;\n}\n\n.dash-ladder-lbl span.on {\n  color: #4fe0c2;\n  font-weight: 500;\n}\n\n.dash-ladder-note {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-top: 25px;\n  padding-top: 18.75px;\n  border-top: 1px solid rgba(255, 255, 255, 0.14);\n  font-size: 15.625px;\n  color: #a9bae0;\n}\n\n.dash-ladder-note .dash-btn-ghost {\n  flex: none;\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.dash-ladder-note .dash-btn-ghost:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.dash-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid #dfe7e8;\n  margin: 20px 0;\n  overflow-x: auto;\n}\n\n.dash-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 15px;\n  font-size: 16.875px;\n  color: #5f7484;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  white-space: nowrap;\n  background: transparent;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  transition: color 0.14s, border-color 0.14s;\n  width: auto !important;\n}\n\n.dash-tab:hover {\n  color: #0b1e2d;\n}\n\n.dash-tab.on {\n  color: #012060;\n  border-bottom-color: #012060;\n  font-weight: 500;\n}\n\n.dash-tab-n {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 13.125px;\n  padding: 1px 7px;\n  border-radius: 99px;\n  background: #eaf0f0;\n  color: #5f7484;\n}\n\n.dash-tab.on .dash-tab-n {\n  background: #e8eef8;\n  color: #012060;\n}\n\n@media (max-width: 980px) {\n  .dash-posture-grid {\n    grid-template-columns: 1fr;\n    gap: 22px;\n  }\n\n  .dash-rule-v {\n    display: none;\n  }\n\n  .dash-reuse-big {\n    font-size: 52px;\n  }\n\n  .dash-ladder-note {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .dash-title {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
